require("./appendPublicationToWebIcon");
require("./attendeechooser2");
require("./attendees");
